<h2 mat-dialog-title>Add Vehicle</h2>

<form [formGroup]="formGroup">
	<mat-dialog-content>
		<app-vehicle-basic-information-edit
				formControlName="vehicle"
				[showJustRequiredFields]="true">
		</app-vehicle-basic-information-edit>

		@if (isCreating) {
			<mat-progress-bar mode="indeterminate"></mat-progress-bar>
		}

		@if (createError) {
			<mat-error>{{createError}}</mat-error>
		}
	</mat-dialog-content>

	<mat-dialog-actions>
		<button mat-stroked-button
				mat-dialog-close>
			Cancel
		</button>
		<button mat-flat-button
				[disabled]="formGroup.invalid || formGroup.pending || isCreating"
				(click)="createVehicle('list')"
				color="primary"
				type="submit"
                class="flex-row-reverse">
            Add Vehicle
            <mat-icon [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">arrow_drop_down</mat-icon>
		</button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="createVehicle('detail')">Add Vehicle & Configure</button>
        </mat-menu>
	</mat-dialog-actions>
</form>
